import styled from 'styled-components'

export const HistoryContainer = styled.div`
    background-color: #E3E3E3;
    width: 100%;
`

export const TitleDescription = styled.div`
  text-align: center;
  padding-top: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  
  p:nth-child(1) {
    color: rgba(186, 0, 1, 1);
    font-size: 3em;
    font-weight: bold;
  }

  p:nth-child(2){
    color: rgba(234, 11, 42, 1);
    font-size: 20em;
    font-weight: 700;
    text-transform: uppercase;
    margin-top: -100px;
  }
  
  p:nth-child(3){
    width: 40%;
    margin-top: 24px;

    @media (max-width: 550px) {
      /* Phones */
       width: 80%;
    }

    @media (max-width: 1100px) {
        /* Tablets */
        width: 80%;
    }

    span{
      font-weight: 500;
    }
  }
`

export const TitleTimeline = styled.div`
  max-width: 1500px;
  margin: 0 auto;
`

export const HorizontalTimelineContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  align-items: center;
`